import { createGlobalState } from 'react-use';
import { useCallback } from 'react';

import {
   DEFAULT_ELEVENLABS_CONFIG,
   DEFAULT_ELEVENLABS_DIARIZATION_CONFIG,
   ElevenLabsTranscriptionConfig,
} from '../transcription/ElevenLabsTranscriptionConfig';

type AiAssistantProviderGlobalState = {
   dictationConfig: ElevenLabsTranscriptionConfig;
   continuousConfig: ElevenLabsTranscriptionConfig;
};

const useGlobalState = createGlobalState<AiAssistantProviderGlobalState>({
   dictationConfig: DEFAULT_ELEVENLABS_CONFIG,
   continuousConfig: DEFAULT_ELEVENLABS_DIARIZATION_CONFIG,
});

type UseAiAssistantProviderGlobalStateResult = {
   dictationConfig: ElevenLabsTranscriptionConfig;
   continuousConfig: ElevenLabsTranscriptionConfig;
   setDictationConfig: (config: ElevenLabsTranscriptionConfig) => void;
   setContinuousConfig: (config: ElevenLabsTranscriptionConfig) => void;
};

export const useAiAssistantProviderGlobalState = (): UseAiAssistantProviderGlobalStateResult => {
   const [state, setState] = useGlobalState();

   const setDictationConfig = useCallback(
      (dictationConfig: ElevenLabsTranscriptionConfig) => {
         setState((prev) => ({ ...prev, dictationConfig: dictationConfig }));
      },
      [setState]
   );

   const setContinuousConfig = useCallback(
      (continuousConfig: ElevenLabsTranscriptionConfig) => {
         setState((prev) => ({ ...prev, continuousConfig: continuousConfig }));
      },
      [setState]
   );

   return {
      dictationConfig: state.dictationConfig,
      continuousConfig: state.continuousConfig,
      setDictationConfig: setDictationConfig,
      setContinuousConfig: setContinuousConfig,
   };
};
